import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { customApp } from '../../_configuration/configuration';
import { IBigBlueButtonSettings } from '@sv/interfaces';

@Injectable({
  providedIn: 'root'
})
export class BigBlueButtonService {
  constructor(private http: HttpClient) {}

  join(bbbSettings: IBigBlueButtonSettings, eventName: string) {
    return this.http.post<{ status: string; data: string }>(customApp.url + `/app/bbb/join?eventName=${eventName}`, bbbSettings);
  }
}
